function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Filter results - Replaces current filter value
 *
 * Will trigger new search
 *
 * @param name String field name to filter on
 * @param value String field value to filter on
 * @param type String (Optional) type of filter to apply
 */


export default function setFilter(name, value) {
  var _console;

  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "all"; // eslint-disable-next-line no-console

  if (this.debug) (_console = console).log.apply(_console, ["Action", "setFilter"].concat(Array.prototype.slice.call(arguments)));
  var filters = this.state.filters;
  filters = filters.filter(function (filter) {
    return filter.field !== name || filter.type !== type;
  });

  this._updateSearchResults({
    current: 1,
    filters: [].concat(_toConsumableArray(filters), [{
      field: name,
      values: [value],
      type: type
    }])
  });
}